import { gql } from '@apollo/client';
import { IMAGE_VARIANT_FRAGMENT } from './media.fragments';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';
import { BASE_SITE_FRAGMENT, SITE_FRAGMENT } from './site.fragments';
import { VIDEO_FRAGMENT } from './video.fragments';

export const BASE_ACTIVITY_FRAGMENT = gql`
  fragment baseActivityValues on Activity {
    id
    title
    createdTimestamp
    lang
  }
`;

export const ACTIVITY_LOG_FRAGMENT = gql`
  fragment activityLogValues on ActivityLog {
    id
    comment
    userEmail
    user {
      firstName
      lastName
      email
    }
    company {
      id
      name
      logo {
        ...imageVariant
      }
    }
    timestamp
    action
  }
  ${IMAGE_VARIANT_FRAGMENT}
`;

export const ACTIVITY_FRAGMENT = gql`
  fragment activityValues on Activity {
    ...baseActivityValues
    langs
    description
    mediaList {
      ... on Video {
        ...videoValues
      }
      ... on ImageVariant {
        ...imageVariant
      }
    }
    latestLog {
      ...activityLogValues
    }
    ownedBy {
      ...basePartnerCompanyValues
    }
    component {
      id
      title
      rawMaterials {
        id
        title
      }
    }
    subActivities {
      id
      title
    }
    site {
      ...siteValues
    }
  }
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${BASE_ACTIVITY_FRAGMENT}
  ${ACTIVITY_LOG_FRAGMENT}
  ${IMAGE_VARIANT_FRAGMENT}
  ${VIDEO_FRAGMENT}
  ${SITE_FRAGMENT}
`;

export const ACTIVITY_LIST_FRAGMENT = gql`
  fragment activityListValues on Activity {
    ...baseActivityValues
    mediaList {
      ... on Video {
        ...videoValues
      }
      ... on ImageVariant {
        ...imageVariant
      }
    }
    latestLog {
      ...activityLogValues
    }
    ownedBy {
      ...basePartnerCompanyValues
    }
    component {
      id
      title
      rawMaterials {
        id
        title
      }
    }
    site {
      ...baseSiteValues
    }
  }
  ${BASE_ACTIVITY_FRAGMENT}
  ${ACTIVITY_LOG_FRAGMENT}
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${BASE_SITE_FRAGMENT}
  ${IMAGE_VARIANT_FRAGMENT}
  ${VIDEO_FRAGMENT}
`;
